import { useEffect, useLayoutEffect } from "react";

/**
 * useIsomorphicLayoutEffect
 *
 * A hook that uses useLayoutEffect on the client and useEffect on the server.
 * This prevents SSR warnings in frameworks like Gatsby, Next.js, etc.
 *
 * During SSR, there's no DOM to measure, so useLayoutEffect would cause warnings.
 * On the client, useLayoutEffect ensures synchronous updates before paint.
 */
export const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
